import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ContentHeader from "../components/ContentHeader";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch { return ""; }
};

const Insights = () => {
  const navigate = useNavigate();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useSEO(
    "Insights — Mortgage Servicing & Foreclosure Prevention | Mortgage Survival Playbook 2026",
    "Practical analysis for mortgage servicers, banks, and credit unions on early borrower-risk identification, structured intervention, loss mitigation, and servicing governance."
  );

  useEffect(() => {
    axios.get(`${API}/articles`)
      .then(({ data }) => setArticles(data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: "100vh" }} data-testid="insights-page">
      <ContentHeader />
      <div className="hero-bg" />
      <div className="insights-hero">
        <div className="eyebrow">Institutional Insights</div>
        <h1>Mortgage Servicing &amp; <em>Foreclosure-Prevention</em> Insights</h1>
        <p>
          Practical analysis for mortgage servicers, banks, and credit unions on early borrower-risk
          identification, structured intervention, loss mitigation, and servicing governance — from the team
          behind the Mortgage Survival Playbook 2026.
        </p>
      </div>

      {loading ? (
        <div className="insights-empty" data-testid="insights-loading">Loading insights…</div>
      ) : articles.length === 0 ? (
        <div className="insights-empty" data-testid="insights-empty">
          New insights are published regularly. Check back shortly.
        </div>
      ) : (
        <div className="insights-grid" data-testid="insights-grid">
          {articles.map((a) => (
            <button
              key={a.id}
              className="insight-card"
              onClick={() => navigate(`/insights/${a.slug}`)}
              data-testid={`insight-card-${a.slug}`}
            >
              {a.tags?.length > 0 && (
                <div className="insight-card-tags">
                  {a.tags.slice(0, 3).map((t, i) => (
                    <span className="insight-tag" key={i}>{t}</span>
                  ))}
                </div>
              )}
              <h3>{a.title}</h3>
              <p>{a.excerpt || a.meta_description}</p>
              <div className="insight-card-meta">
                <span>{formatDate(a.published_at || a.created_at)}</span>
                <span className="insight-card-read">Read →</span>
              </div>
            </button>
          ))}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Insights;
